<template>
  <div class="pb-2 d-flex justify-content-between">
    <div class="d-flex align-items-center overflow-hidden text-medium-1">
      <activity-label :team-id="teamId" :action-label="actionLabel" :activity="activity" />
      <i class="caret-right-icon mr-2 flex-shrink-0" v-if="showTeamOrgName"></i>
      <div :title="teamOrgName" class="text-truncate" v-if="showTeamOrgName" v-no-capture>
        {{ teamOrgName }}
      </div>
    </div>
    <div class="d-flex align-items-center">
      <span class="time text-nowrap">
        <router-link :to="getEntityHref(true)" class="text-secondary text-small pointer">
          {{ getTimeOrDate(createdAt) }}
        </router-link>
      </span>
      <div class="actions d-flex align-items-center">
        <give-award-icon
          class="ml-2 icon-wrapper"
          :context="awardContext"
          :class="themeColor"
          v-if="awardContext"
          @awarded="$emit('awarded')"
        />
        <post-reaction-icon
          class="ml-1 flex-center icon-wrapper"
          :class="themeColor"
          :event="activity"
          @reacted="$emit('reacted', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityLabel from '@/components/activity/ActivityLabel'
import PostReactionIcon from '@/components/reactions/PostReactionIcon'
import GiveAwardIcon from '@/components/award/GiveAwardIcon'
import ActivityMixin from '@/mixins/ActivityMixin'
import { getTimeOrDate } from '@/utils/formatDate'

/**
 * This component renders header for activity. It renders in below format
 * "Alice added a comment"
 * "Alice" - is determined from prop - activity
 * "added a comment" - is prop - actionLabel
 */
export default {
  name: 'ActivityHeader',
  props: {
    activity: Object,
    actionLabel: String,
    teamId: Number,
    awardContext: Object,
    showTeamOrgName: {
      type: Boolean,
      default: true
    },
    createdAt: String,
    themeColor: String // possible values: primary | secondary
  },
  mixins: [ActivityMixin],
  components: {
    ActivityLabel,
    GiveAwardIcon,
    PostReactionIcon
  },
  methods: {
    getTimeOrDate
  },
  computed: {
    /*
    It returns name of the team this activity belongs to
     */
    teamOrgName() {
      return this.$store.getters.teamById(this.teamId)?.name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.icon-wrapper {
  @include dimension(21px, 21px);

  background: $quinary;
  padding: 4px;
  border-radius: 3px;

  &.secondary {
    background: $brandQuaternary;
  }
}

/deep/ .emoji-field {
  display: flex;
}

.time {
  margin-top: 1px;
  padding-left: 4px;
}

.caret-right-icon {
  margin-top: 3px;
}
</style>
